export default function PHP_endwhile() {
  return (
    <div>
      <h1>PHP_endwhile</h1>
    </div>
  );
}
